import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { MinusCircle, Search } from "lucide-react";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { decryptToken } from "../utils/getToken";
import Loader from "../Loader";
import "../CRMUpdatedVersion/LeadsUpdatedVersion.css";
import "./InvoiceStyle.css";

export default function CreditNotes() {
  const navigate = useNavigate();
  const url = API_BASE_URL;
  const user = getDecryptedUserFromCookie("gta_mainstateuser");
  const token = decryptToken("accessToken") || "";
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!user?.main_id) return;
      setLoading(true);
      try {
        const res = await fetch(
          `${url}/newinvoice/all/${user.main_id}?document_type=credit_note`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = await res.json();
        setNotes(Array.isArray(data) ? data : []);
      } catch (err) {
        toast.error("Could not load credit notes");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const filtered = notes.filter((n) => {
    if (!search.trim()) return true;
    const s = search.toLowerCase();
    return (
      String(n.invoice_number || "").toLowerCase().includes(s) ||
      String(n.customer_name || "").toLowerCase().includes(s)
    );
  });

  if (loading) return <Loader />;

  return (
    <div className="lsuv-oms">
      <div className="lsuv-oms__header">
        <div className="lsuv-tabs-oms">
          <div className="lsuv-tab-oms lsuv-tab-oms-active">
            <MinusCircle size={16} style={{ marginRight: 6 }} />
            Credit notes
          </div>
        </div>
        <div
          className="text-black size-8 rounded-full flex justify-center items-center bg-gray-100 hover:bg-gray-200 cursor-pointer"
          onClick={() => setShowSearch((v) => !v)}
        >
          <Search size={18} />
        </div>
      </div>

      {showSearch && (
        <input
          type="search"
          placeholder="Search credit note or customer…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: "100%", maxWidth: 320, padding: "8px 12px", marginBottom: 12 }}
        />
      )}

      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Credit note #</th>
              <th>Customer</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ textAlign: "center", padding: 24 }}>
                  No credit notes yet. Issue one from an invoice with a remaining balance.
                </td>
              </tr>
            ) : (
              filtered.map((n) => (
                <tr key={n.id}>
                  <td>{n.invoice_number}</td>
                  <td>{n.customer_name}</td>
                  <td>{n.invoice_date}</td>
                  <td>₹{parseFloat(n.grand_total || 0).toFixed(2)}</td>
                  <td>
                    <button
                      type="button"
                      className="omsnewbutton-copy"
                      onClick={() => navigate(`/invoice-detail/${n.id}`)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
